(function () {
  function initHelpCenter(root) {
    const scope = root || document.getElementById('VrvHelpCenter');
    if (!scope || scope.dataset.vrvHcBound) return;
    scope.dataset.vrvHcBound = 'true';

    const navItems = scope.querySelectorAll('[data-vrv-hc-nav]');
    const panels = scope.querySelectorAll('[data-vrv-hc-panel]');

    function showCategory(id) {
      navItems.forEach((btn) => {
        const on = btn.dataset.vrvHcNav === id;
        btn.classList.toggle('is-active', on);
        btn.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      panels.forEach((panel) => {
        const on = panel.dataset.vrvHcPanel === id;
        panel.hidden = !on;
        panel.classList.toggle('is-active', on);
      });
    }

    navItems.forEach((btn) => {
      btn.addEventListener('click', () => showCategory(btn.dataset.vrvHcNav));
    });

    scope.querySelectorAll('[data-vrv-hc-accordion]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const item = btn.closest('.vrv-hc__faq-item');
        const expanded = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        item.classList.toggle('is-open', !expanded);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', () => initHelpCenter());
})();
